import _objectSpread from "@babel/runtime/helpers/objectSpread2";
import "core-js/modules/es6.array.filter.js";
import "core-js/modules/es6.string.includes.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.map.js";
import React from 'react';
import baseStyles from '@nerdwallet/base-styles/react';
import Image from '@nerdwallet/react-image';
/**
 * Return a MediaItem object with sizes filtered by a given array of size labels
 *
 * @param mediaItem - query0 MediaItem object
 * @param sizes - Array of media sizes to return
 */

var filterMediaSizes = function filterMediaSizes(mediaItem, sizes) {
  var _mediaItem$mediaDetai, _mediaItem$mediaDetai2;

  if (!(mediaItem !== null && mediaItem !== void 0 && (_mediaItem$mediaDetai = mediaItem.mediaDetails) !== null && _mediaItem$mediaDetai !== void 0 && (_mediaItem$mediaDetai2 = _mediaItem$mediaDetai.sizes) !== null && _mediaItem$mediaDetai2 !== void 0 && _mediaItem$mediaDetai2.length)) return mediaItem;
  return _objectSpread(_objectSpread({}, mediaItem), {}, {
    mediaDetails: _objectSpread(_objectSpread({}, mediaItem.mediaDetails), {}, {
      sizes: mediaItem.mediaDetails.sizes.filter(function (_ref) {
        var size = _ref.size;
        return sizes.includes(size);
      })
    })
  });
};
/**
 * Get a `srcSet` containing all the images at the same ratio of a given image size.
 *
 * @param mediaItem - query0 MediaItem object.
 *
 * @return a `srcSet` string.
 */


var getMediaSrcSetGql = function getMediaSrcSetGql(mediaItem) {
  var _mediaItem$mediaDetai3, _mediaItem$mediaDetai4;

  if (!(mediaItem !== null && mediaItem !== void 0 && (_mediaItem$mediaDetai3 = mediaItem.mediaDetails) !== null && _mediaItem$mediaDetai3 !== void 0 && (_mediaItem$mediaDetai4 = _mediaItem$mediaDetai3.sizes) !== null && _mediaItem$mediaDetai4 !== void 0 && _mediaItem$mediaDetai4.length)) return '';
  return mediaItem.mediaDetails.sizes.sort(function (a, b) {
    return a.width - b.width;
  }).map(function (currSize) {
    var srcUrl = currSize === null || currSize === void 0 ? void 0 : currSize.sourceUrl;
    var width = currSize === null || currSize === void 0 ? void 0 : currSize.width;
    return "".concat(srcUrl, " ").concat(width, "w");
  }).join(', ');
};

export var FeaturedImage = function FeaturedImage(_ref2) {
  var _filterMediaSizes, _filterMediaSizes$med, _filterMediaSizes$med2;

  var data = _ref2.data,
      hideOnMobile = _ref2.hideOnMobile,
      fetchPriority = _ref2.fetchPriority;
  var featuredImageInfo = (_filterMediaSizes = filterMediaSizes(data, ['primary-l', 'primary-m'])) === null || _filterMediaSizes === void 0 ? void 0 : (_filterMediaSizes$med = _filterMediaSizes.mediaDetails) === null || _filterMediaSizes$med === void 0 ? void 0 : (_filterMediaSizes$med2 = _filterMediaSizes$med.sizes) === null || _filterMediaSizes$med2 === void 0 ? void 0 : _filterMediaSizes$med2[0];
  var featuredImageSrcSet = getMediaSrcSetGql(filterMediaSizes(data, ['primary-xxxl', 'primary-xxl', 'primary-xl', 'primary-l', 'primary-m']));

  if (!(featuredImageSrcSet && featuredImageInfo)) {
    return null;
  }

  return /*#__PURE__*/React.createElement("div", baseStyles({
    'display-none': hideOnMobile,
    'display-block--wide': hideOnMobile
  }), /*#__PURE__*/React.createElement(Image, {
    alt: data.altText || '',
    aspectRatio: "10:4",
    src: featuredImageInfo.sourceUrl,
    srcSet: featuredImageSrcSet,
    fetchPriority: fetchPriority
  }));
};